import Base from '@/plugins/Base';
import router from '@/plugins/Router'
import UndergraduateTransferService from '@/services/UndergraduateTransferService'
import showErrors from '@/helpers/showErrors'

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        nationalID: null,
        pin: null,
        time: null,
        tab: -1,
        mernis: null,
    }),
    getters: {
        getData(state) {
            return state.data
        },
        getStatus(state){
            return state.data && state.data.status ? state.data.status:null;
        },
        getNationalID(state) {
            return state.nationalID
        },
        getPin(state) {
            return state.pin
        },
        getTime(state) {
            return state.time
        },
        getTab(state) {
            return state.tab
        },
        getMernis(state) {
            return state.mernis
        }
    },

    mutations: {
        setData(state, data) {
            state.data = data
            Base.LocalStorage.set('cartoon_animation_app_data', state.data)
        },
        setStatus(state, status) {
            state.data.status = status;
            Base.LocalStorage.set('undergraduate_transfer_data', state.data)
        },
        setNationalID(state, nationalID) {
            state.nationalID = nationalID
            Base.LocalStorage.set('cartoon_animation_app_id', state.nationalID)
        },
        setPin(state, pin) {
            state.pin = pin
            Base.LocalStorage.set('cartoon_animation_app_pin', state.pin)
        },
        setTime(state, time) {
            state.time = time
            Base.LocalStorage.set('cartoon_animation_app_time', state.time)
        },
        clearData(state) {
            state.data = {}
            state.nationalID = null
            state.pin = null
        },
        setTab(state, tab) {
            state.tab = tab
            Base.LocalStorage.set('cartoon_animation_app_tab', state.tab)
        },
        setMernis(state, mernis){
            state.mernis = mernis
            Base.LocalStorage.set('cartoon_animation_app_mernis', state.mernis)
        },
        clearMernis(state){
            state.mernis = null
            Base.LocalStorage.set('cartoon_animation_app_mernis', null)
        }
    },

    actions: {
        initData({commit}) {
            let data = Base.LocalStorage.get('cartoon_animation_app_data')
            let nationalID = Base.LocalStorage.get('cartoon_animation_app_id')
            let pin = Base.LocalStorage.get('cartoon_animation_app_pin')
            let time = Base.LocalStorage.get('cartoon_animation_app_time')
            let tab = Base.LocalStorage.get('cartoon_animation_app_tab')
            let mernis = Base.LocalStorage.get('cartoon_animation_app_mernis')
            if (data && nationalID && pin) {
                commit('setData', data)
                commit('setNationalID', nationalID)
                commit('setPin', pin)
                commit('setTime', time)
                commit('setTab', tab)
                commit('setMernis', mernis)
            }
        },

        isLogin({state}) {

            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (!data || !nationalID || !pin) {
                router.push('/cartoon/animation/application/login')
            }
        },

        isLoginGoIndex({state}) {
            let data = state.data;
            let nationalID = state.nationalID;
            let pin = state.pin;
            if (data && nationalID && pin) {
                router.push('/cartoon/animation/application/form')
            }
        },

        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('cartoon_animation_app_data')
            Base.LocalStorage.remove('cartoon_animation_app_id')
            Base.LocalStorage.remove('cartoon_animation_app_pin')
            Base.LocalStorage.remove('cartoon_animation_app_time')
            Base.LocalStorage.remove('cartoon_animation_app_tab')
            Base.LocalStorage.remove('cartoon_animation_app_mernis')

            router.push('/cartoon/animation/application/login')
        }
    }
}

export default module;
